import React from "react";

export const KurtMark = ({ size = 36, className = "" }) => (
  <div
    className={`relative flex items-center justify-center rounded-xl shrink-0 ${className}`}
    style={{
      width: size,
      height: size,
      background: "linear-gradient(135deg, #10B981 0%, #059669 60%, #047857 100%)",
      boxShadow: "0 4px 18px rgba(16,185,129,0.35)",
    }}
  >
    <span
      className="kz-head font-extrabold text-[#04140d]"
      style={{ fontSize: size * 0.5, lineHeight: 1 }}
    >
      K
    </span>
  </div>
);
